export const initialDataState = {
  showDetailedValues: false,
  data: [],
  busy: true,
  filter: "option3",
};
